import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const LawFirmToolkit = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default LawFirmToolkit